import React, { useState } from 'react';
import Modal from './Modal';
import ContentImage from './ContentImage';
export default function Videos() {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const videosData = [
        {
            id: 1,
            title: "Ranní relaxace",
            description: "Probuďte své tělo i mysl jemnou ranní sestavou čchi-kung, která vás naladí na pozitivní vlnu a dodá energii do celého dne. Cvičení je navrženo tak, aby uvolnilo napětí, zlepšilo dýchání a přineslo vnitřní klid. Skvělé pro každodenní domácí praxi i začátečníky.",
            thumbnail: "https://img.youtube.com/vi/BwyJAAeCook/maxresdefault.jpg",
            videoUrl: "https://www.youtube.com/embed/BwyJAAeCook",


            category: "Ranní cvičení"
        },
        {
            id: 2,
            title: "Večerní flow",
            description: "Zklidněte se po náročném dni a dopřejte si večerní čchi-kung flow, které pomáhá uvolnit stres a navodit hlubokou relaxaci. Lekce vás provede základními pohyby a technikami, které podpoří regeneraci těla i mysli. Ideální pro večerní zklidnění a lepší spánek.",
            thumbnail: "https://img.youtube.com/vi/C_GdG1UgTAI/maxresdefault.jpg",
            videoUrl: "https://www.youtube.com/embed/C_GdG1UgTAI",


            category: "Úvodní lekce"
        },
        {
            id: 3,
            title: "Podzimní pohyb v barvách země",
            description: "Objevte harmonii podzimního období prostřednictvím této speciální čchi-kung sestavy inspirované barvami a energií země. Cvičení spojuje jemné pohyby s hlubokým dýcháním a pomáhá vám naladit se na přirozený rytmus podzimní přírody. Ideální pro posílení vnitřní stability a uzemnění.",
            thumbnail: "https://img.youtube.com/vi/VbgPTnu0U9Y/maxresdefault.jpg",
            videoUrl: "https://www.youtube.com/embed/VbgPTnu0U9Y",


            category: "Sezónní cvičení"
        }
    ];


    return <section className="py-20 bg-gray-900"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="content-page-heading"><p className="eyebrow">Vlastním tempem</p><h1>Malá chvíle pro sebe.</h1><p>Krátké sestavy a inspirace pro domácí praxi. Najděte si klidné místo a nechte se vést pohybem.</p></div>
        <div className="editorial-grid">{videosData.map(video => <article className="editorial-card" key={video.id}>
            <button type="button" className="video-preview" onClick={() => setSelectedVideo(video)} aria-label={`Přehrát: ${video.title}`}>
                <ContentImage src={video.thumbnail.replace('maxresdefault','hqdefault')} alt={video.title} loading="lazy" />
                <span className="play-icon" aria-hidden="true">▷</span>
            </button>
            <div className="editorial-card-body"><span className="editorial-date">{video.category}</span><h2>{video.title}</h2><p>{video.description}</p><button className="text-link" type="button" onClick={() => setSelectedVideo(video)}>Přehrát cvičení ↗</button></div>
        </article>)}</div>
    </div>
    {selectedVideo && <Modal label={selectedVideo.title} onClose={() => setSelectedVideo(null)}>
        <h2 className="video-modal-title">{selectedVideo.title}</h2>
        <iframe className="video-frame" src={`${selectedVideo.videoUrl.replace('youtube.com', 'youtube-nocookie.com')}?autoplay=1&rel=0`} title={selectedVideo.title} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
        <p className="video-modal-description">{selectedVideo.description}</p>
    </Modal>}
    </section>;
}
